import { arrayToString } from './arrayToString';
import { ELECTION_TYPE, CM_PRIMARY_ID } from './constants';
import { getNominationRoundYear } from './getNominationRoundYear';

export const tableRowsValuesNominationHistory = (
  resultData,
  proposers,
  electionTypes,
  nominationStatusType,
  sectionalCommitteesWithCmse,
  fellows,
) =>
  resultData?.map((item) => {
    const disciplineDescriptorLabels = arrayToString(
      item.attributes.disciplineDescriptor,
    );
    const overlapDisciplineDescriptorLabels = arrayToString(
      item.attributes.overlapDisciplineDescriptor,
    );
    const interdisciplinaryCommitteeLabels = arrayToString(
      item.attributes.interdisciplinaryCommittee,
    );

    let sectionalCommitteeKey = item.attributes.sectionalCommitteeId;
    if (
      item.attributes.electionTypeId &&
      parseInt(item.attributes.electionTypeId) !== ELECTION_TYPE.ORDINARY
    ) {
      sectionalCommitteeKey = CM_PRIMARY_ID;
    }

    const roundYear = item?.attributes?.roundYear;
    const lastConsideredDate = item?.attributes?.lastConsideredDate;

    const lastConsidered = lastConsideredDate
      ? getNominationRoundYear(new Date(lastConsideredDate))
      : '';

    const { nominationId } = item.attributes;

    return {
      nominationId,
      candidateId: item.attributes.candidateId,
      candidate: item.attributes.candidate,
      proposerName: fellows[proposers[nominationId]],
      electionTypeId: electionTypes[item.attributes.electionTypeId],
      nominationStatusType:
        nominationStatusType[item.attributes.nominationStatusTypeId],
      nominationStatusTypeId: item.attributes.nominationStatusTypeId,
      sectionalCommitteeId:
        item.attributes.deprecatedSectionalCommitteeLabel ??
        sectionalCommitteesWithCmse[sectionalCommitteeKey] ??
        '',
      overlapSectionalCommitteeId:
        sectionalCommitteesWithCmse[
          item.attributes.overlapSectionalCommitteeId
        ],
      roundYear,
      lastConsidered,
      ranking: item.attributes.ranking,
      overlapDisciplineDescriptor: overlapDisciplineDescriptorLabels,
      disciplineDescriptor: disciplineDescriptorLabels,
      interdisciplinaryCommittee: interdisciplinaryCommitteeLabels,

      createdAt: item.attributes.createdAt,
      updatedAt: item.attributes.publishedAt,
      publishedAt: item.attributes.updatedAt,
    };
  });
